export default function clone<T>(item: T): T {
	return JSON.parse(JSON.stringify(item));
}